// =============================================================================
// Provides a generic loader. Currently wraps spin.js, but could wrap anything.
// -----------------------------------------------------------------------------

import Spinner from "spin.js";

function fadeBetween(el, start, fin, ms) {
	/* eslint-disable */
	return;

	el.style.opacity = start;
	let last = +new Date();
	const raf = window.requestAnimationFrame;
	const diff = fin - start;
	let ticks = 0;

	const tick = () => {
		const now = +new Date();
		el.style.opacity = +el.style.opacity + (diff * (now - last) / ms);
		last = now;
		ticks++;

		if (
			(start > fin && el.style.opacity <= fin) ||
			(start < fin && el.style.opacity >= fin)
		) {
			el.style.opacity = fin;
			return;
		}

		if (raf) {
			raf(tick);
		} else {
			setTimeout(tick, 16);
		}
	};

	tick();

	/* eslint-enable */
}


export default class OkLoader {
	/**
	 * Pass in an element to overlay the loader, and optional params if needed.
	 * @arg {Element|JQuery} el - The element you want applied to, jquery or vanilla.
	 * @arg {object} opts - A dictionary of options.
	 * @arg {string} opts.size - A size of loader. Options are: 'tiny', 'small', 'large'.
	 * @arg {string} opts.color - Override the default color with #hexval.
	 * @arg {int}    opts.fade - Milliseconds of fade in / out. Defaults to 150.
	 * @arg {string} opts.top - CSS top property. Defaults to 50%.
	 * @arg {string} opts.left - CSS left property. Defaults to 50%.
	 * @return {OkLoader}
	 */
	constructor(el, opts = {}) {
		this.options = opts;
		this.changeTarget(el);
		this.animSpeed = 150;

		const spinOptions = {
			lines: 12,
			length: 12,
			radius: 12,
			width: 4,
			speed: 1.5,
			trail: 80,
			top: "50%",
			left: "50%",
			color: "#5e6573",
		};

		if (opts.size) {
			if (opts.size === "tiny" || opts.size === "xsmall") {
				spinOptions.length = 6;
				spinOptions.radius = 6;
				spinOptions.width = 2;
				spinOptions.speed = 1.4;
			} else if (opts.size === "small") {
				spinOptions.length = 8;
				spinOptions.radius = 10;
				spinOptions.width = 3;
			} else if (opts.size === "large") {
				spinOptions.length = 16;
				spinOptions.radius = 14;
				spinOptions.width = 5;
			}
		}

		if (opts.color) {
			spinOptions.color = opts.color;
		}

		if (opts.top) {
			spinOptions.top = opts.top;
		}

		if (opts.left) {
			spinOptions.left = opts.left;
		}

		if (opts.fade !== null && opts.fade !== undefined) {
			this.animSpeed = opts.fade;
		}

		this.animSpeed = 0;

		this.spinner = new Spinner(spinOptions);
		return this;
	}

	/**
	 * Start the loader animation.
	 * @return {OkLoader}
	 */
	start() {
		this.el.className += " loading";
		this.spinner.spin(this.el);
		fadeBetween(this.el, 0, 1, this.animSpeed);
		return this;
	}

	/**
		 * Stop the loader animation.
		 * @return {OkLoader}
		 */
	stop() {
		fadeBetween(this.el, 1, 0, this.animSpeed);

		setTimeout(() => {
			this.el.className = this.el.className.replace("loading", "");
			this.spinner.stop();
		}, this.animSpeed);

		return this;
	}

	/**
	 * Change what element the loader attaches to.
	 * @arg {Element|JQuery} el - The element you want it attached to, jQuery or vanilla.
	 * @return {OkLoader}
	 */
	changeTarget(el) {
		if (el.jquery || el.constructor === Array) {
			this.el = el[0];
		}
		else {
			this.el = el;
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/OkLoader.js